/* global FormData */
import React, { useRef, useState, useEffect, useContext } from "react";
import { AiFillCamera } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import OImage from "components/reusable/OImage";
import { useForm } from "react-hook-form";
import OButton from "components/reusable/OButton";
import { apiPost } from "utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { apiGet } from "../../utils/apiFetch";
import helpers from "../../utils/helpers";
import AuthContext from "context/AuthContext";
import OInputField from "components/reusable/OInputField";
import formValidation from "utils/formValidation";
import noImage from "../../assets/images/No-image-found.jpg";
import ErrorMessage from "components/ErrorMessage";
import { MdCancel } from "react-icons/md";
import useToastContext from "hooks/useToastContext";

const platforms = [
  { id: "web", label: "Web" },
  { id: "app", label: "App" },
  { id: "noshow", label: "don't show anywhere" },
];

const HomeAd = ({ addHomeAdBanner, manager }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const [bannerImage, setBannerImage] = useState(null);
  const [bannerImageError, setBannerImageError] = useState("");
  const notification = useToastContext();
  const bannerImageRef = useRef();
  const [adBanner, setAdBanner] = useState([]);
  const [platform, setPlatform] = useState("web");
  const handleFileChange = (e) => {
    const image = e?.target?.files[0];

    const isValidImage = handleFileUploadSingle(e);
    if (isValidImage) {
      if (e?.target?.name === "adbannerImage") {
        setBannerImage(image);
        setBannerImageError("");
      }
    }
  };
  const permission = user?.permission?.find(
    (e) => e.manager === "ads_and_banner_manager",
  );
  const homeAdBanner = async () => {
    try {
      const path = apiPath.getHomeAdBanner;
      const result = await apiGet(path);
      const response = result?.data?.results;
      setAdBanner(response);
      setPlatform(response?.platform);
      setValue("redirectLink", response?.redirectLink);
      setValue("recordId", response?.recordId);
      setValue("screenName", response?.screenName);
      setValue("id", response?._id);
      setBannerImage(response?.AdImage);
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    resetField,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
  });
  const checkValidation = () => {
    let isValid = true;
    if (!bannerImage) {
      isValid = false;
      setBannerImageError("Please select home ad banner image.");
    }
    return isValid;
  };
  const onSubmit = async (data) => {
    try {
      const isValid = checkValidation();
      if (!isValid) {
        return;
      }
      const formData = new FormData();
      formData.append("adbannerImage", bannerImage);
      formData.append("platform", platform);
      if (data.redirectLink) formData.append("redirectLink", data.redirectLink);
      if (data?.screenName) formData.append("screenName", data?.screenName);
      if (data?.recordId) formData.append("recordId", data?.recordId);

      reset();
      const path = !addHomeAdBanner
        ? `${apiPath.editHomeAd}/${data.id}`
        : `${apiPath.addHomeAd}`;
      const res = await apiPost(path, formData);
      if (res.data) {
        if (res.data.success) {
          homeAdBanner();
          notification.success(res.data.message);
          setBannerImage(res.data.results?.AdImage);
        }
        if (addHomeAdBanner) {
          addHomeAdBanner.fn(false);
        }
      }
    } catch (err) {
      console.error("err:", err);
    } finally {
      // setUpdatePrfileLoading(false)
      // notification.success(loginMessage)
    }
  };

  const handleFileUploadSingle = (e) => {
    const getType = e.target.files[0].type.split("/");
    const fileSize = (e.target.files[0]?.size / (1024 * 1024)).toFixed(2);
    if (
      getType[1] !== undefined &&
      (getType[1] === "jpeg" ||
        getType[1] === "png" ||
        getType[1] === "jpg" ||
        getType[1] === "gif")
    ) {
      if (fileSize > 2) {
        notification.error("Please select image below 2 MB");
        return false;
      }
      return true;
    } else {
      notification.error("Only jpeg,png,jpg,gif formats are allowed");
      // notification.error('Only jpeg,png,jpg,gif formats are allowed')
    }
  };

  useEffect(() => {
    homeAdBanner();
  }, []);

  const handlePlatformChange = (id) => {
    setPlatform(id);
    if (id === "web") {
      resetField("recordId");
      resetField("screenName");
      setValue("redirectLink", adBanner?.redirectLink);
    }

    if (id === "app") {
      resetField("redirectLink");
      setValue("recordId", adBanner?.recordId);
      setValue("screenName", adBanner?.screenName);
    }
    if (id === "noshow") {
      resetField("redirectLink");
      resetField("recordId");
      resetField("screenName");
    }
    setValue("id", adBanner?._id);
  };

  return (
    <div className="border-0 rounded-lg  relative flex flex-col w-full bg-white outline-none focus:outline-none">
      <div className="relative p-6 flex-auto">
        <div className="">
          {/* <div className='mb-4'>
            <h3 className='text-xl font-semibold'>{t('Add_BANNER_FORM')}</h3>
          </div> */}

          <div className="flex">
            <div className="flex flex-col justify-center">
              <div className="flex-col border bg-white px-6 py-14 shadow-md rounded-[4px] max-w-[1000px] w-full">
                <h3 className="text-md font-semibold">Platform</h3>
                <div className="flex items-center gap-6 mb-4">
                  {platforms.map(({ id, label }) => (
                    <div key={id} className="flex gap-2">
                      <label htmlFor={id}>{label}</label>
                      <input
                        disabled={
                          !(
                            manager?.add ||
                            user?.role === "admin" ||
                            permission?.add
                          )
                        }
                        onChange={() => handlePlatformChange(id)}
                        checked={platform === id}
                        id={id}
                        type="radio"
                      />
                    </div>
                  ))}
                </div>
                {platform === "web" ? (
                  <>
                    <div className="flex flex-col text-sm rounded-md">
                      <OInputField
                        wrapperClassName=""
                        name="redirectLink"
                        inputLabel={
                          <>
                            {t("AD_LINK")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        autoFocus
                        disabled={
                          !(
                            manager?.add ||
                            user?.role === "admin" ||
                            permission?.add
                          )
                        }
                        register={register(
                          "redirectLink",
                          formValidation.redirectLink,
                        )}
                        errors={errors}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex flex-col text-sm rounded-md">
                      <OInputField
                        wrapperClassName=""
                        name="recordId"
                        inputLabel={
                          <>
                            {t("AD_RECORD_ID")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        autoFocus
                        disabled={
                          !(
                            manager?.add ||
                            user?.role === "admin" ||
                            permission?.add
                          )
                        }
                        register={register("recordId", formValidation.recordId)}
                        errors={errors}
                      />
                      <OInputField
                        wrapperClassName=""
                        name="screenName"
                        inputLabel={
                          <>
                            {t("AD_SCREEN_NAME")}
                            <span className="text-red-500">*</span>
                          </>
                        }
                        type="text"
                        autoFocus
                        disabled={
                          !(
                            manager?.add ||
                            user?.role === "admin" ||
                            permission?.add
                          )
                        }
                        register={register(
                          "screenName",
                          formValidation.screenName,
                        )}
                        errors={errors}
                      />
                    </div>
                  </>
                )}
                {(manager?.add || user?.role === "admin") && (
                  <div className="text-center">
                    <OButton
                      label={<>{t("O_UPDATE")}</>}
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                    />
                  </div>
                )}
                <div className="px-4 py-4 text-sm whitespace-nowrap">
                  <div className="flex">
                    <h4 className="text-gray-700 dark:text-gray-200 mr-3">
                      {t("O_LAST_UPDATED")}
                    </h4>
                    <p className="text-gray-500 dark:text-gray-400">
                      {helpers.dateFormat(adBanner?.updatedAt)}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center">
              {(bannerImage || adBanner.AdImage) && (
                <>
                  <div className="w-[750px] ml-4 h-[200px]">
                    <h2 className="text-2xl pb-2">
                      {" "}
                      <strong>Website Image</strong>
                    </h2>
                    <label className="mb-2 block">
                      Image Resolution (3:1) (Horizontal)
                    </label>
                    {!bannerImage ? (
                      <>
                        <div
                          id="FileUpload"
                          className="relative mb-5.5 block w-full cursor-pointer appearance-none rounded border-2 border-dashed border-primary bg-gray py-5 px-4 dark:bg-meta-4 sm:py-7.5"
                        >
                          <input
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                            onChange={handleFileChange}
                            name="adbannerImage"
                            className="absolute inset-0 z-50 m-0 h-full w-full cursor-pointer p-0 opacity-0 outline-none"
                          />
                          <div className="flex flex-col items-center justify-center space-y-3">
                            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-stroke bg-white dark:border-strokedark dark:bg-boxdark">
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M1.99967 9.33337C2.36786 9.33337 2.66634 9.63185 2.66634 10V12.6667C2.66634 12.8435 2.73658 13.0131 2.8616 13.1381C2.98663 13.2631 3.1562 13.3334 3.33301 13.3334H12.6663C12.8431 13.3334 13.0127 13.2631 13.1377 13.1381C13.2628 13.0131 13.333 12.8435 13.333 12.6667V10C13.333 9.63185 13.6315 9.33337 13.9997 9.33337C14.3679 9.33337 14.6663 9.63185 14.6663 10V12.6667C14.6663 13.1971 14.4556 13.7058 14.0806 14.0809C13.7055 14.456 13.1968 14.6667 12.6663 14.6667H3.33301C2.80257 14.6667 2.29387 14.456 1.91879 14.0809C1.54372 13.7058 1.33301 13.1971 1.33301 12.6667V10C1.33301 9.63185 1.63148 9.33337 1.99967 9.33337Z"
                                  fill="#3C50E0"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.5286 1.52864C7.78894 1.26829 8.21106 1.26829 8.4714 1.52864L11.8047 4.86197C12.0651 5.12232 12.0651 5.54443 11.8047 5.80478C11.5444 6.06513 11.1223 6.06513 10.8619 5.80478L8 2.94285L5.13807 5.80478C4.87772 6.06513 4.45561 6.06513 4.19526 5.80478C3.93491 5.54443 3.93491 5.12232 4.19526 4.86197L7.5286 1.52864Z"
                                  fill="#3C50E0"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.99967 1.33337C8.36786 1.33337 8.66634 1.63185 8.66634 2.00004V10C8.66634 10.3682 8.36786 10.6667 7.99967 10.6667C7.63148 10.6667 7.33301 10.3682 7.33301 10V2.00004C7.33301 1.63185 7.63148 1.33337 7.99967 1.33337Z"
                                  fill="#3C50E0"
                                />
                              </svg>
                            </span>
                            <p className="font-medium text-sm">
                              <span className="text-primary">
                                Click to upload
                              </span>
                              {/* or drag and drop */}
                            </p>
                            {/* <p className='mt-1.5 font-medium text-sm'>
                    SVG, PNG, JPG or GIF
                  </p>
                  <p className='font-medium text-sm'>(max, 800 X 800px)</p> */}
                          </div>
                        </div>
                        {bannerImageError && (
                          <ErrorMessage message={bannerImageError} />
                        )}
                      </>
                    ) : (
                      <>
                        <div className="border w-full  rounded-md relative">
                          <button
                            className=" flex items-center justify-center text-white rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none absolute top-[-4px] right-[0px]   w-[40px] h-[40px]"
                            onClick={() => setBannerImage("")}
                            disabled={!(manager?.add || user?.role === "admin")}
                          >
                            <span className="  text-2xl " title="Delete">
                              <MdCancel />
                            </span>
                          </button>

                          <input
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"
                            name="adbannerImage"
                            ref={bannerImageRef}
                            onChange={handleFileChange}
                            className="hidden"
                          />
                          <OImage
                            src={
                              typeof bannerImage === "object"
                                ? URL.createObjectURL(bannerImage)
                                : adBanner.AdImage
                            }
                            fallbackUrl={noImage}
                            className="w-full h-full object-cover"
                            alt=""
                          />
                          <button
                            type="button"
                            className=" align-center absolute top-0 end-0 p-3 rounded bg-black text-white cursor-pointer"
                            onClick={() => bannerImageRef?.current?.click()}
                            disabled={!(manager?.add || user?.role === "admin")}
                          >
                            <AiFillCamera />
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAd;
